import { hasFieldChangedValue } from '../../../../../Helpers/FormInputHelper';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';

export const haveFieldsChanged = (bankDetails, editedBankDetails) => {
  return (
    hasFieldChangedValue(editedBankDetails?.type, bankDetails?.type) ||
    hasFieldChangedValue(editedBankDetails?.number, bankDetails?.number)
  );
};

export const validateBankAccount = bankAccount => {
  const errors = [];
  if (!bankAccount.number?.trim()) {
    errors.push({});
  }
  if (!bankAccount.type?.trim()) {
    errors.push({
      inputId: 'type',
      message: formatMessage(Messages.agentBankAccount_typeNotSet),
    });
  }

  return errors;
};
